import React, { useState } from 'react';
import { connect } from 'react-redux';
import { sendTenantInvitation } from '../../actions/reduxActions/organizations';
import InviteForm from './InviteForm';
import { REGEX_PATTERN_TENANT_NAME, REGEX_TENANT_NAME, REGEX_PATTERN_GUID, REGEX_GUID } from '../../constants';

export const validateAndSetInputValue = ({ 
    inputElement,
    setIdentifierPropertyName, 
    setInputValue, 
}) => {
    const { value } = inputElement;
    const propertyName = REGEX_TENANT_NAME.test(value) 
        ? 'developerName' 
        : REGEX_GUID.test(value)
            ? 'id'
            : null;

    if (inputElement.validity.patternMismatch) {
        inputElement.setCustomValidity('Please match the required name or ID format');
    } else {
        inputElement.setCustomValidity('');            
    }

    setIdentifierPropertyName(propertyName);
    setInputValue(value);
};

export const submitAndResetForm = ({ 
    sendInvitation, 
    setInputValue, 
    setIdentifierPropertyName, 
    identifierPropertyName, 
    currentUser,
    inputValue,
}) => { 
    sendInvitation({
        authenticationToken: currentUser.authenticationToken,
        tenantId: currentUser.tenantId,
        inviteTenantData: {
            [identifierPropertyName]: inputValue,
        },
    });
    setInputValue('');
    setIdentifierPropertyName(null);
};

export const TenantInvite = ({
    currentUser,
    sendInvitation,
    closeModal,
}) => {

    const [inputValue, setInputValue] = useState('');
    const [identifierPropertyName, setIdentifierPropertyName] = useState(null);

    const validationPattern = `^@${REGEX_PATTERN_TENANT_NAME}$|${REGEX_PATTERN_GUID}`;

    const onInput = ({ target: inputElement }) => validateAndSetInputValue({ 
        inputElement,
        setIdentifierPropertyName, 
        setInputValue, 
    });

    const onSubmit = (event) => {
        event.preventDefault();
        submitAndResetForm({ 
            sendInvitation, 
            setInputValue, 
            setIdentifierPropertyName, 
            identifierPropertyName, 
            currentUser,
            inputValue,
        });
        closeModal();
    };

    const renderHelpBlock = () => (
        <label className="help-block">
            e.g. @tenantName.manywho.com
            <br />
            or xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
            <br />
            Subtenants cannot be invited
        </label>
    );

    return (
        <>
            <InviteForm 
                inputLabel="Tenant name or ID"
                onSubmit={onSubmit}
                onCancel={closeModal}
                onInput={onInput}
                inputValue={inputValue}
                renderHelpBlock={renderHelpBlock}
                validationPattern={validationPattern}
            />
        </>
    );
};

const mapDispatchToProps = {
    sendInvitation: sendTenantInvitation,
};

export default connect(
    null,
    mapDispatchToProps,
)(TenantInvite);
